<template>
  <div class="mt-4 mx-5">
    <div class="row">
      <div class="col-8">
        <h2>{{ title }}</h2>
        <h5>{{ description }}</h5>
      </div>
      <div class="col-4">
        <div class="d-flex justify-content-end align-items-center">
          <b-form-checkbox
            v-model="alleBemerkungenAnzeigen"
            button
            button-variant="outline-primary"
            size="sm"
            class="mr-2"
          >
            <font-awesome-icon icon="fa-regular fa-message-captions" />
            {{ alleBemerkungenAnzeigen ? t('public.remarks_close_all') : t('public.remarks_open_all') }}
          </b-form-checkbox>
          <div class="language-selection">
            <b-button
              variant="outline-primary"
              class="mx-1"
              size="sm"
              @click="changeLanguage('de')"
              >DE</b-button
            >
            <b-button
              variant="outline-primary"
              class="mr-1"
              size="sm"
              @click="changeLanguage('fr')"
              >FR</b-button
            >
            <b-button
              variant="outline-primary"
              class="mr-1"
              size="sm"
              @click="changeLanguage('en')"
              >EN</b-button
            >
            <b-button
              variant="outline-primary"
              class="mr-1"
              size="sm"
              @click="changeLanguage('it')"
              >IT</b-button
            >
          </div>
        </div>
      </div>
    </div>

    <div class="row mt-10-px">
      <div v-for="(frage, index) in fragen" :key="index" class="col-xl-4 pt-2">
        <div class="tile-container">
          <div class="tile-categorie-frame">
            <div class="tile-categorie">
              <div class="header">
                <span v-if="frage.sort != 0">{{ frage.sort + " " }}</span
                ><span>{{ frage.designation }}</span>
                <b-form-checkbox
                  class="float-right mr-1"
                  size="sm"
                  button
                  button-variant="outline-primary"
                  v-model="frage.bemerkungenAnzeigen"
                  ><font-awesome-icon
                    icon="fa-regular fa-message-captions"
                    v-tooltip.hover="(text = t('public.remarks'))"
                /></b-form-checkbox>
              </div>
              <div class="body">
                <div class="row">
                  <div
                    v-if="
                      frage.questiontype.designation == 'Singlechoice' ||
                      frage.questiontype.designation == 'Multiplechoice'
                    "
                    class="col-xl-12"
                  >
                    <column-chart
                      :data="prepareChartData(frage)"
                      height="300px"
                      :colors="['#add58c']"
                      :legend="false"
                      :xtitle="t('public.answers')"
                      :ytitle="t('public.number')"
                    ></column-chart>
                    <div
                      v-if="frage.bemerkungenAnzeigen == true"
                      class="col-12"
                    >
                      <div
                        v-for="(result, index) in frage.results"
                        :key="index"
                      >
                        <div v-if="personal">
                          {{
                            index +
                            1 +
                            ". " +
                            result.gp.vorname +
                            " " +
                            result.gp.name +
                            ": " +
                            (result.answers && result.answers.length > 0 ? result.answers.map((a) => a.designation).join(", ") : "-")
                          }}
                        </div>
                        <div v-if="frage.bemerkungenAnzeigen == true">
                          <span class="txtTrsf">
                            {{
                              t("public.remark") +
                              " : " +
                              (result.remark != null ? result.remark : "-")
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="frage.questiontype.designation == 'Text'"
                    class="col-xl-12"
                  >
                    <div v-for="(result, index) in frage.results" :key="index">
                      <div v-if="personal">
                        {{
                          index +
                          1 +
                          ". " +
                          result.gp.vorname +
                          " " +
                          result.gp.name +
                          ": " +
                          (result.answertext != null ? result.answertext : "-")
                        }}
                      </div>
                      <div v-else>
                        {{
                          t("public.answer") +
                          " " +
                          (index + 1) +
                          ": " +
                          (result.answertext != null ? result.answertext : "-")
                        }}
                      </div>
                      <div v-if="frage.bemerkungenAnzeigen == true">
                        <span class="txtTrsf">
                          {{
                            t("public.remark") +
                            " : " +
                            (result.remark != null ? result.remark : "-")
                          }}
                        </span>
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="frage.questiontype.designation == 'Range'"
                    class="col-xl-12"
                  >
                    <column-chart
                      :data="prepareRangeData(frage)"
                      :colors="['#1ad7e1']"
                      :legend="false"
                      :xtitle="t('public.rangevalue')"
                      :ytitle="t('public.number')"
                    ></column-chart>
                    <div
                      v-if="frage.bemerkungenAnzeigen == true"
                      class="col-12"
                    >
                      <div
                        v-for="(result, index) in frage.results"
                        :key="index"
                      >
                        <div v-if="personal">
                          {{
                            index +
                            1 +
                            ". " +
                            result.gp.vorname +
                            " " +
                            result.gp.name +
                            ": " +
                            (result.range_value != null ? result.range_value : "-")
                          }}
                        </div>
                        <div v-if="frage.bemerkungenAnzeigen == true">
                          <span class="txtTrsf">
                            {{
                              t("public.remark") +
                              " : " +
                              (result.remark != null ? result.remark : "-")
                            }}
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <login-modal
      ref="loginModal"
      id="auswertung-login-modal"
      :header-text="t('public.login_title')"
      :text="t('public.login_text')"
      :username-text="t('public.username')"
      :password-text="t('public.password')"
      :login-text="t('public.login')"
      :error-text="t('public.login_error')"
      @login="onLogin"
    />
  </div>
</template>

  <script>
import QuestionaireApi from "@/api/QuestionaireApi";
import page from "@/mixins/Page";
import LoginModal from "@/components/Modals/LoginModal";
import questionaire from "../../store/questionaire";

export default {
  name: "Auswertung",
  components: { LoginModal },
  mixins: [page],
  props: {
    id: {
      type: String,
      default: null,
    },
    personal: {
      type: Boolean,
      default: null,
    },
  },
  data() {
    return {
      fragen: [],
      title: null,
      description: null,
      translations: {
        de: {
          public: {
            answers: "Antworten",
            number: "Anzahl",
            answer: "Antwort",
            rangevalue: "Wert",
            remark: "Bemerkung",
            remarks: "Bemerkungen/Details",
            remarks_open_all: "Alle öffnen",
            remarks_close_all: "Alle schliessen",
            login_title: "Anmeldung erforderlich",
            login_text:
              "Dies ist eine persönliche Umfrage. Bitte melden Sie sich an, um die Auswertung zu sehen.",
            username: "Benutzername",
            password: "Passwort",
            login: "Login",
            login_error: "Anmeldung fehlgeschlagen",
          },
        },
        fr: {
          public: {
            answers: "Réponses",
            number: "Nombre",
            answer: "Réponse",
            rangevalue: "Valeur",
            remark: "Remarque",
            remarks: "Remarques/détails",
            remarks_open_all: "Tout ouvrir",
            remarks_close_all: "Tout fermer",
            login_title: "Connexion requise",
            login_text:
              "Ce sondage est personnel. Veuillez vous connecter pour voir l'évaluation.",
            username: "Nom d'utilisateur",
            password: "Mot de passe",
            login: "Connexion",
            login_error: "Échec de la connexion",
          },
        },
        en: {
          public: {
            answers: "Answers",
            number: "Number",
            answer: "Answer",
            rangevalue: "Value",
            remark: "Remark",
            remarks: "Remarks/Details",
            remarks_open_all: "Open all",
            remarks_close_all: "Close all",
            login_title: "Login required",
            login_text:
              "This is a personal survey. Please log in to see the evaluation.",
            username: "User name",
            password: "Password",
            login: "Login",
            login_error: "Login failed",
          },
        },
        it: {
          public: {
            answers: "Risposte",
            number: "Numero",
            answer: "Risposta",
            rangevalue: "Valore",
            remark: "Note",
            remarks: "Note/Dettagli",
            remarks_open_all: "Apri tutto",
            remarks_close_all: "Chiudi tutto",
            login_title: "Accesso richiesto",
            login_text:
              "Questo è un sondaggio personale. Effettuare l'accesso per vedere la valutazione.",
            username: "Nome utente",
            password: "Password",
            login: "Accesso",
            login_error: "Accesso non riuscito",
          },
        },
      },
      currentLanguage: "de",
    };
  },
  created() {
    // Bei einer persönlichen Umfrage werden Teilnehmernamen angezeigt, deshalb wird
    // hier - im Gegensatz zur anonymen Auswertung - ein Login verlangt.
    // App.vue lädt den angemeldeten Mitarbeiter, bevor die Seite gerendert wird:
    // ist er nicht gesetzt, ist niemand angemeldet.
    if (this.personal && !this.angemeldeterMitarbeiter) {
      this.$nextTick(() => this.$refs.loginModal.openModal());
    } else {
      this.ladeAuswertung();
    }
  },
  mounted() {},
  computed: {
    alleBemerkungenAnzeigen: {
      get() {
        return this.fragen.length > 0 && this.fragen.every((f) => f.bemerkungenAnzeigen);
      },
      set(val) {
        this.fragen.forEach((f) => { f.bemerkungenAnzeigen = val; });
      },
    },
  },
  methods: {
    onLogin() {
      // Neu laden, damit App.vue den angemeldeten Mitarbeiter, die Berechtigungen
      // und die Kategorien mit der neuen Session lädt.
      window.location.reload();
    },
    ladeAuswertung() {
      QuestionaireApi.get("/result/", {
        params: { id: this.id, personal: this.personal },
      }).then((response) => {
        this.fragen = response.data.results.map((frage) => ({
          ...frage,
          bemerkungenAnzeigen: false, // Standardwert setzen
        }));
        this.title = response.data.title;
        this.description = response.data.description;
      });
    },
    prepareChartData(frage) {
      return frage.answers.map((answer) => {
        const count = frage.results.reduce((acc, result) => {
          return acc + (result.answers.some((a) => a.id === answer.id) ? 1 : 0);
        }, 0);
        return [answer.designation, count]; // Erstellt ein Array mit Label und Count
      });
    },
    prepareRangeData(frage) {
      const rangeStart = parseInt(frage.rangestart, 10);
      const rangeEnd = parseInt(frage.rangeend, 10);
      const rangeCount = new Array(rangeEnd - rangeStart + 1).fill(0);
      // Zählt die Anzahl jeder range_value in den results
      frage.results.forEach((result) => {
        const value = result.range_value - rangeStart;
        if (value >= 0 && value < rangeCount.length) {
          rangeCount[value]++;
        }
      });
      // Erstellt das Datenarray für die Chart-Komponente
      return rangeCount.map((count, index) => {
        return [`${rangeStart + index}`, count];
      });
    },
    changeLanguage(lang) {
      this.currentLanguage = lang;
    },
    t(key) {
      return this.translations[this.currentLanguage][key.split(".")[0]][
        key.split(".")[1]
      ];
    },
    anzeigen(value) {
      console.log(value.bemerkungenAnzeigen);
      this.fragen[value].bemerkungenAnzeigen
        ? (this.fragen[value].bemerkungenAnzeigen = false)
        : (this.fragen[value].bemerkungenAnzeigen = true);
      console.log(value.bemerkungenAnzeigen);
    },
  },
};
</script>
